import React from 'react';

const SearchComponent: React.FC<{
  searchKeyword: string;
  handleSearchInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  getThemes: any;
}> = ({ searchKeyword, handleSearchInputChange, getThemes }) => {

  const isWhiteOrShade = (color: string): boolean => {
    const s = color.trim().toLowerCase();
    if (s === "white" || s === "#fff" || s === "#ffffff" || s === "rgb(255,255,255)" || s === "rgba(255,255,255,1)") return true;
    let r: number, g: number, b: number;
    if (s.startsWith("#")) {
      let hex = s.slice(1);
      if (hex.length === 3) hex = hex.split("").map(ch => ch + ch).join("");
      if (hex.length !== 6 || !/^[0-9a-f]{6}$/i.test(hex)) return false;
      r = parseInt(hex.slice(0, 2), 16);
      g = parseInt(hex.slice(2, 4), 16);
      b = parseInt(hex.slice(4, 6), 16);
    } else {
      const m = s.match(/rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*[\d.]+)?\s*\)/);
      if (!m) return false;
      r = Number(m[1]);
      g = Number(m[2]);
      b = Number(m[3]);
    }
    return r >= 235 && g >= 235 && b >= 235;
  };

  const borderColor = getThemes && isWhiteOrShade(getThemes.color1) ? getThemes.color2 : getThemes.color1;

  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.333 12.667A5.333 5.333 0 1 0 7.333 2a5.333 5.333 0 0 0 0 10.667ZM14 14l-2.9-2.9" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <input
        type="text"
        id="searchProperty"
        className="py-2 pl-9 pr-3 rounded-full text-sm transition-all duration-200 outline-none"
        placeholder="Search by street or postcode"
        value={searchKeyword}
        onChange={handleSearchInputChange}
        style={{
          border: `1.5px solid #D1D5DB`,
          width: '250px',
        }}
        onFocus={(e) => {
          e.currentTarget.style.borderColor = borderColor;
          e.currentTarget.style.boxShadow = `0 0 0 2px ${borderColor}22`;
        }}
        onBlur={(e) => {
          e.currentTarget.style.borderColor = '#D1D5DB';
          e.currentTarget.style.boxShadow = 'none';
        }}
      />
    </div>
  );
};

export default SearchComponent;
